import { getFilterIndicator } from "../helpers";
import type { ComparisonType } from "../types";

import type { FilterStrategy } from "./types";

const COMP_SYMBOLS: Record<ComparisonType, string> = {
  eq: "=",
  gte: "≥",
  lte: "≤",
};

export const numberStrategy: FilterStrategy = {
  search(filterType, ctx, out) {
    if (ctx.parsedNumber === null) return;
    const score = ctx.looksLikeDate ? 40 : 80;
    if (ctx.parsedNumberQuery?.comparison) {
      const cmp = ctx.parsedNumberQuery.comparison;
      out.push({
        filterKey: filterType.filterKey,
        filterLabel: filterType.label,
        optionValue: `__number_${cmp}__`,
        optionLabel: `${COMP_SYMBOLS[cmp]} ${ctx.parsedNumber}`,
        type: filterType.type,
        comparison: cmp,
        numericValue: ctx.parsedNumber,
        score,
        indicator: getFilterIndicator(filterType, true),
      });
      return;
    }
    const comparisons: { comparison: ComparisonType; symbol: string }[] = [
      { comparison: "eq", symbol: "=" },
      { comparison: "gte", symbol: "≥" },
      { comparison: "lte", symbol: "≤" },
    ];
    for (const c of comparisons) {
      out.push({
        filterKey: filterType.filterKey,
        filterLabel: filterType.label,
        optionValue: `__number_${c.comparison}__`,
        optionLabel: `${c.symbol} ${ctx.parsedNumber}`,
        type: filterType.type,
        comparison: c.comparison,
        numericValue: ctx.parsedNumber,
        score,
        indicator: getFilterIndicator(filterType, true),
      });
    }
  },
  isSelected(currentValue, _optionValue, comparison, numericValue) {
    if (
      comparison &&
      numericValue !== undefined &&
      typeof currentValue === "object" &&
      currentValue !== null &&
      "comparison" in currentValue &&
      "value" in currentValue
    ) {
      return (
        currentValue.comparison === comparison &&
        currentValue.value === numericValue
      );
    }
    return false;
  },
  toggle(result) {
    if (result.comparison && result.numericValue !== undefined) {
      return {
        value: { value: result.numericValue, comparison: result.comparison },
      };
    }
    return { value: result.optionValue };
  },
};
